import { Injectable } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { UtilService } from './util.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { StorageService } from './storage.service';
import { StorageEnum } from '../enums/storage.enum';
import { ErrorData } from '../models/error-data';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { Router } from '@angular/router';
import { Nav } from '../enums/nav.enum';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  allErrors: any;
  genericError: any;

  constructor(
    private readonly utilService: UtilService,
    private readonly storage: StorageService,
    private readonly router: Router,
  ) {
    this.allErrors = storage.getSession(StorageEnum.GlobalVars)?.allErrors;
    this.genericError = storage.getSession(StorageEnum.GlobalVars)?.genericApiError;
  }

  goToTechnicalError(): void {
    this.utilService.showSpinner();
    void this.router.navigateByUrl(Nav.TechnicalError);
  }

  setErrorData(errorCode: string, pageData: any): void {
    let foundError: any;
    if (errorCode !== 'none') {
      foundError = this.allErrors.find((error: any) => {
        return error.error?.errorCode === errorCode;
      });
    }
    if (foundError || errorCode === 'none') {
      const errorDetail = new ErrorData();
      errorDetail.Header = foundError?.error.errorHeader ? foundError?.error.errorHeader : pageData.value.data.header;
      errorDetail.Subheader = foundError?.error.displayMessage
        ? foundError.error.displayMessage
        : pageData.value.data.subheaderText
          ? pageData.value.data.subheaderText
          : '';

      if (pageData.value.data.ctaList && pageData.value.data.ctaList.length > 0) {
        const ctaLabels = pageData.value.data.ctaList[0];
        errorDetail.CtaButton.Label = ctaLabels.ctaLabel;
        errorDetail.CtaButton.Link = ctaLabels.ctaUrl;
        errorDetail.CtaButton.AriaLabel = ctaLabels.ctaAriaLabel;
      }

      if (pageData.value.data.linkList && pageData.value.data.linkList.length > 0) {
        const ctaLinkLabels = pageData.value.data.linkList[0];
        errorDetail.CtaLink.Label = ctaLinkLabels.ctaLabel;
        errorDetail.CtaLink.Link = ctaLinkLabels.ctaUrl;
        errorDetail.CtaLink.AriaLabel = ctaLinkLabels.ctaAriaLabel;
      }
      this.storage.setSession(StorageEnum.ErrorData, errorDetail);
    } else {
      const errorDetail = new ErrorData();
      errorDetail.Header = this.genericError.header;
      errorDetail.Subheader = this.genericError.subheaderText;
      errorDetail.CtaButton.Label = this.genericError.ctaList[0].ctaLabel;
      errorDetail.CtaButton.Link = this.genericError.ctaList[0].ctaUrl;
      errorDetail.CtaButton.AriaLabel = this.genericError.ctaList[0].ctaAriaLabel;
      this.storage.setSession(StorageEnum.ErrorData, errorDetail);
    }
  }
}
